"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageOcrType = exports.TaskName = void 0;
/**
 * Names of the tasks that can be executed during an inspection.
 *
 * *Swagger Schema Reference :* `TaskName`
 */
var TaskName;
(function (TaskName) {
    /**
     * Detection of damages on different parts of the car (except the wheels).
     */
    TaskName["DAMAGE_DETECTION"] = "damage_detection";
    /**
     * Inspection of the condition of the wheels.
     */
    TaskName["WHEEL_ANALYSIS"] = "wheel_analysis";
    /**
     * Estimation of the repair operations (and their cost) that has to be done to fix the damages detected by the
     * damage detection task.
     */
    TaskName["REPAIR_ESTIMATE"] = "repair_estimate";
    /**
     * Optical character recognition  : this task is used to automatically "scan" some text like the VIN number for
     * instance.
     */
    TaskName["IMAGES_OCR"] = "images_ocr";
})(TaskName = exports.TaskName || (exports.TaskName = {}));
/**
 * The different types of element that can be recognized during an OCR task.
 *
 * *Swagger Schema Reference :* `ImageOcrType`
 */
var ImageOcrType;
(function (ImageOcrType) {
    /**
     * A passport identifying a person.
     */
    ImageOcrType["PASSPORT"] = "PASSPORT";
    /**
     * A national french id (located on the ID card for instance).
     */
    ImageOcrType["ID_FR"] = "ID_FR";
    /**
     * National french registration papers.
     */
    ImageOcrType["VEHICLE_REGISTRATION_PAPERS_FR"] = "VEHICLE_REGISTRATION_PAPERS_FR";
    /**
     * A vehicle identification number identifying worldwide a vehicle.
     */
    ImageOcrType["VIN"] = "VIN";
})(ImageOcrType = exports.ImageOcrType || (exports.ImageOcrType = {}));
//# sourceMappingURL=entityTypes.js.map